/**
 * - Idle: no detection run / no server action yet (default when unset)
 * - Pending: detection is in progress
 * - Failed: last run failed; user can retry or place fields manually
 * - Declined: user chose not to use AI
 * - Completed: resolved (success, Acro migration, or user kept AI result)
 */
export enum AiDetectionStatus {
  Idle = 'idle',
  Pending = 'pending',
  Failed = 'failed',
  Declined = 'declined',
  Completed = 'completed',
}

/** Resolve persisted AI detection status from file metadata. */
export function resolveAiDetectionStatusFromFile(
  file: { aiDetectionStatus?: AiDetectionStatus } | undefined,
): AiDetectionStatus {
  return file?.aiDetectionStatus ?? AiDetectionStatus.Idle;
}
